import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { PlayersService } from '../../shared/services/players/players';

export const playersResolver: ResolveFn<any> = (route, state) => {
  const players = inject(PlayersService);
  return players.getPlayersWithGame(route.paramMap.get('id') as string);
};
